// Mirrors backend/server/modules/SharedResources/constants.js — keep in sync.
export const REPORT_TYPES = {
  PERSONAL_CREDIT: 'Personal Credit',
  BUSINESS_CREDIT: 'Business Credit',
  CORTERA: 'Cortera',
  PAYNET: 'Paynet',
  OTHER: 'Other',
}

export const REPORT_TYPE_OPTIONS = Object.entries(REPORT_TYPES).map(([value, label]) => ({ value, label }))

export const MAX_SHARED_FILE_SIZE = 25 * 1000 * 1000 // matches the backend's 25MB multer limit
export const SHARED_FILE_ACCEPT = '.pdf,.png,.jpg,.jpeg,.doc,.docx,.xls,.xlsx,.csv'
export const MAX_SHARED_FILES = 5

// Mirror of the backend PREVIEWABLE_TYPES allowlist. Spreadsheets are rendered
// as an HTML table client-side (SheetJS); PDF/images render natively. Word is
// download-only (no safe inline read-only viewer).
export const SPREADSHEET_TYPES = [
  'application/vnd.ms-excel', // .xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'text/csv', // .csv
]

// .docx renders client-side (docx-preview); the old binary .doc has no client
// renderer, so it is intentionally left out (download-only).
export const WORD_DOCX_TYPE = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

export const getPreviewKind = (mimeType) => {
  if (mimeType === 'application/pdf') return 'pdf'
  if (mimeType === 'image/png' || mimeType === 'image/jpeg') return 'image'
  if (SPREADSHEET_TYPES.includes(mimeType)) return 'spreadsheet'
  if (mimeType === WORD_DOCX_TYPE) return 'word'
  return null
}

export const isPreviewable = (mimeType) => getPreviewKind(mimeType) !== null
